module.exports = "//static.hsappstatic.net/HubspotToolsMenu/static-1.99/css/toolsmenu.css"